import * as tingle from "tingle.js";

/**
 * Create Fundraiser Examples loaded via ajax and placed into a Tingle popup
 */
export function fundraiserExamples(e: Event, ajaxPopup: HTMLElement, viewSampleModal: tingle.modal): void {
    e.preventDefault();
    viewSampleModal.setContent("<cmnh-loading loading='true'></cmnh-loading>");
    const url = ajaxPopup.getAttribute("href") as string;
    $(".campaign-preview .tingle-modal-box__content").load(`${url} main`);

    viewSampleModal.open();
}
